import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-cbcd917c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "save-display" }
const _hoisted_2 = {
  key: 0,
  class: "display-flex"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "italic" }, "Noe gikk galt", -1))
const _hoisted_4 = {
  key: 1,
  class: "display-flex"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "italic" }, "Lagrer", -1))
const _hoisted_6 = {
  key: 2,
  class: "display-flex"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "italic" }, "Lagret", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SvgIcon = _resolveComponent("SvgIcon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.form.hasErrors && !_ctx.form.processing)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_SvgIcon, {
            class: "error-icon",
            width: "1.2rem",
            height: "1.2rem",
            type: "mdi",
            path: _ctx.failureIcon
          }, null, 8, ["path"]),
          _hoisted_3
        ]))
      : (_ctx.form.processing || (_ctx.form.isDirty && _ctx.eager))
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createVNode(_component_SvgIcon, {
              class: "animate-spin",
              width: "1.2rem",
              height: "1.2rem",
              type: "mdi",
              path: _ctx.loadingIcon
            }, null, 8, ["path"]),
            _hoisted_5
          ]))
        : (_ctx.form.wasSuccessful)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createVNode(_component_SvgIcon, {
                class: "success-icon",
                width: "1.2rem",
                height: "1.2rem",
                type: "mdi",
                path: _ctx.successIcon
              }, null, 8, ["path"]),
              _hoisted_7
            ]))
          : _createCommentVNode("", true)
  ]))
}